import React from "react";
import "../css/contact.css";
import "../css/style.css";

function Contact() {
  return (
    <div className="contact-page-container">
      <div className="contact-content-wrapper">
        <div className="contact-intro">
          <h1>Let's Connect</h1>
          <p>
            I'm always open to discussing new opportunities, security
            challenges, or collaboration on interesting projects.
          </p>
        </div>

        <div className="contact-details">
          <div className="contact-item-new">
            <div className="contact-icon-new">
              <i className="fas fa-envelope"></i>
            </div>
            <div className="contact-text-new">
              <h3>Email</h3>
              <a href="mailto:a3ravichandran@ucsd.edu">
                a3ravichandran@ucsd.edu
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
